import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserInfo } from "@models/user";
import { catchError, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthService } from "./auth.service";
import { SnackBarService } from "./snack-bar.service";
import {
  BecomeOrganizarIndividualRequest,
  BecomeOrganizerCompanyRequest,
} from "./types/become-organizer.type";

@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  private readonly baseUrl = `${environment.API_BACKEND}/users`;

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
    private readonly notificationService: SnackBarService,
  ) {}

  becomeProducer(
    body: BecomeOrganizarIndividualRequest | BecomeOrganizerCompanyRequest,
  ) {
    return this.http
      .post<UserInfo>(`${this.baseUrl}/become_organizer`, body)
      .pipe(
        tap((response) => {
          this.authService.updateLocalStorageUserInfo(response);

          this.notificationService.openSnackBar(
            "Cadastro atualizado com sucesso",
            "Fechar",
            "success",
          );
        }),
        catchError((err) => {
          this.notificationService.openSnackBar(
            "Erro ao atualizar cadastro",
            "Fechar",
            "error",
          );

          return err;
        }),
      );
  }
}
